"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AutoHideFollowButton = _interopRequireDefault(require("./ScrollToBottom/AutoHideFollowButton"));

var _Composer = _interopRequireDefault(require("./ScrollToBottom/Composer"));

var _Panel = _interopRequireDefault(require("./ScrollToBottom/Panel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ROOT_CSS = (0, _glamor.css)({
  position: 'relative'
});

var BasicScrollToBottom = function BasicScrollToBottom(_ref) {
  var checkInterval = _ref.checkInterval,
      children = _ref.children,
      className = _ref.className,
      debounce = _ref.debounce,
      followButtonClassName = _ref.followButtonClassName,
      mode = _ref.mode,
      scrollViewClassName = _ref.scrollViewClassName;
  return /*#__PURE__*/_react.default.createElement(_Composer.default, {
    checkInterval: checkInterval,
    debounce: debounce,
    mode: mode
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', (className || '') + '')
  }, /*#__PURE__*/_react.default.createElement(_Panel.default, {
    className: scrollViewClassName
  }, children), /*#__PURE__*/_react.default.createElement(_AutoHideFollowButton.default, {
    className: followButtonClassName
  })));
};

BasicScrollToBottom.defaultProps = {
  checkInterval: undefined,
  children: undefined,
  className: undefined,
  debounce: undefined,
  followButtonClassName: undefined,
  mode: undefined,
  scrollViewClassName: undefined
};
BasicScrollToBottom.propTypes = {
  checkInterval: _propTypes.default.number,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  debounce: _propTypes.default.number,
  followButtonClassName: _propTypes.default.string,
  mode: _propTypes.default.oneOf(['bottom', 'top']),
  scrollViewClassName: _propTypes.default.string
};
var _default = BasicScrollToBottom;
exports.default = _default;